import * as React from "react";
import { SVGProps } from "react";

export const IconInProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.313 17.531v-.343h-5.5v-2.75a2.757 2.757 0 012.29-2.712l1.147-.194V8.425L7.137 8.21c-.548-.106-1.062-.419-1.489-.904a3.38 3.38 0 01-.797-1.682l8.212-2.274v1.807c0 .761-.305 1.544-.836 2.149-.427.485-.941.798-1.49.904l-1.112.216v3.107l1.147.194c.443.075.861.26 1.217.535l.978-.978A4.11 4.11 0 0011 10.37v-.811c.844-.164 1.628-.628 2.26-1.346.748-.852 1.178-1.966 1.178-3.057V1.375h.687V0H2.75v1.375h.688v3.781c0 1.09.429 2.205 1.177 3.057.632.718 1.417 1.182 2.26 1.346v.81a4.132 4.132 0 00-3.438 4.069v4.124H2.75v1.375h8.485a1.034 1.034 0 01.032-1.092l.163-.245-.289-.058a1.034 1.034 0 01-.829-1.01z"
      fill="currentColor"
    />
    <path
      d="M21.724 15.132l-1.042-.209a4.439 4.439 0 00-.11-.265l.59-.884a.343.343 0 00-.044-.434l-1.458-1.458a.344.344 0 00-.434-.043l-.883.589a4.359 4.359 0 00-.266-.11l-.209-1.042a.343.343 0 00-.337-.276H15.47a.344.344 0 00-.337.276l-.209 1.042c-.09.034-.178.07-.265.11l-.884-.59a.343.343 0 00-.434.044l-1.458 1.458a.344.344 0 00-.043.434l.589.884c-.04.087-.076.175-.11.265l-1.042.209a.343.343 0 00-.276.337v2.062a.344.344 0 00.276.337l1.042.209c.034.09.07.178.11.265l-.59.884a.343.343 0 00.044.434l1.458 1.458a.344.344 0 00.434.043l.884-.589c.087.04.175.076.265.11l.209 1.042a.343.343 0 00.337.276h2.062a.344.344 0 00.337-.276l.209-1.042c.09-.034.178-.07.265-.11l.884.59a.343.343 0 00.434-.044l1.458-1.458a.344.344 0 00.043-.434l-.589-.883c.04-.088.076-.176.11-.266l1.042-.209a.343.343 0 00.276-.337V15.47a.344.344 0 00-.276-.337zM16.5 18.219a1.72 1.72 0 110-3.44 1.72 1.72 0 010 3.44z"
      fill="currentColor"
    />
  </svg>
);
